// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HighlightOutlinedSvg from "@fishx/icons-svg/es/asn/HighlightOutlined";
import FishxIcon from '../components/FishxIcon';

var HighlightOutlined = function HighlightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HighlightOutlinedSvg
  }));
};

HighlightOutlined.displayName = 'HighlightOutlined';
export default React.forwardRef(HighlightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HighlightOutlined.js
// module id = 2930
// module chunks = 0